import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';


export default function ExamVerification() {

  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }

  const tableRef = useRef(null);



  const [disciplineId, setDisciplineChange] = useState(null);
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [flag, setflag] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [loading, setlodaing] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]); // Object to track selected rows
  const [totalAmount, setTotalAmount] = useState(0); // Track the total amount
  const [examid, setExamIdData] = useState('');
  const [getexamData, setExamData] = useState([]);
  const [courseListData, setCourseListData] = useState([]);
  const [examlink, setExamlink] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [appar, setAappar] = useState(false);
  const [reload, setreload] = useState(0);
  const [disciplines, setDisciplines] = useState([]);
  const [courseDetails, setCourseDetails] = useState([]);

  const { http } = Api();

  let cid = localStorage.getItem("collegeid");

  useEffect(() => {
    const validateQPLogin = async () => {
      try {
        const response = await http.get('/College/validateDwldCollegeLogin');
        // Handle successful response if needed
      } catch (error) {
        if (error.response.data.http_status === 500 && error.response.data.status_code === "ERR44") {
          //toast.error(error.response.data.message);
          //setTimeout(() => {
            navigate("/college/questionpaperdownloadotp");
         // }, 5000);
        } 
        else if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        
        else {
          toast.error("An unexpected error occurred.");
        }
      }
    };

    validateQPLogin();
  }, []); // Include navigate in dependency array to avoid potential issues with closure



  useEffect(() => {
    // Fetch data on page load
    const fetchData = async () => {
      try {
        const response = await http.get("/College/examRegistrationSummary");

        // Save disciplines and courseDetails separately
        setDisciplines(response.data.data.disciplines);
        setCourseDetails(response.data.data.courseDetails);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleGeneratePDFNew = async (qpcode) => {
    try {
      const response = await http.get('/College/SubjectWiseQpDownload', {
        params: {
          qpcode: qpcode
        },
        responseType: 'blob'
      });

      if (response && response.data) {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${localStorage.getItem('username')}_${qpcode}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return Promise.resolve('PDF generated successfully ');

      }

    } catch (error) {
      console.error('Error generating PDF:', error);
      return Promise.reject('Error generating PDF');
    }
  };

  //All Set pdf
  const handleGeneratePDFNewAll = async () => {
    setlodaing(true); // Set loading to true before starting the PDF generation
    try {
      const response = await http.get('/College/downloadQpzp', {
        responseType: 'blob', // Ensure you're receiving a blob
      });

      // Log the response status and headers for debugging
      console.log('API Response:', response);
      console.log('Response Headers:', response.headers);
      //console.log('Response Data:', response.data);

      if (response && response.data) {
        // Extract filename from content-disposition header if available
        const contentDisposition = response.headers['content-disposition'];
        const filename = contentDisposition
          ? contentDisposition.split('filename=')[1].replace(/"/g, '')
          : `${localStorage.getItem('username')}.zip`;

        console.log(filename + "-file");

        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);

        // Create a link to trigger download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Use the extracted filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return Promise.resolve('ZIP generated and downloaded successfully');
      } else {
        console.error('No data found in response');
        return Promise.reject('No data found in response');
      }
    } catch (error) {
      toast.error(error.response.data.message);
      // Log the full error object to understand the root cause
      console.error('Error generating Zip:', error);
      return Promise.reject('Error generating Zip');
    }
    finally {
      setlodaing(false); // Set loading to false once the process is complete
    }
  };






  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (


          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (


          <div className="my-page">

            <div className="container-fluid">

              <div className={`modal fade show ${showModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true" style={{ backdropFilter: 'blur(2px)' }}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className="modal-toggle-wrapper">
                        <h4 className="text-center pb-2">Are you sure you want to Delete ?</h4>
                        <div className="d-flex justify-content-center mt-3">
                          <button className="btn btn-danger mx-2" onClick="">Delete</button>
                          <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick="">Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Question Paper Download</h5>
                          <div className="buttons-container">




                          </div>
                        </div>

                      </div>
                      <div className="card-body">



                        <div className="card-body pdg">
                          <div className="table-responsive">

                            <div className="form theme-form">
                              <div className="card-body custom-input">
                                <div class="table-container">
                                  <h6 className="hed-fnt-wt m-b-10">Exam Registration Summary</h6>

                                  <table className="table-striped table-bordered ex-table" ref={tableRef} id="dataTable">
                                    <thead>
                                      <tr className="col-cnt-tab-bg-clr">
                                        <th scope="col" width="10%">Sl No.</th>
                                        <th scope="col" width="">Programme</th>
                                        <th scope="col" width="">Total Registered Students</th>

                                      </tr>
                                    </thead>

                                    <tbody>
                                      {disciplines.length > 0 ? (
                                        disciplines.map((discipline, index) => (
                                          <tr key={discipline.id}>
                                            <td>{index + 1}</td>
                                            <td>{discipline.discipline_name} - {discipline.specialisation_display_name}</td>
                                            <td>{discipline.cnt}</td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr><td colSpan="3" className="text-center">No data found</td></tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                                <div class="table-container">

                                  <div className="d-flex justify-content-between m-20">
                                    <h6 className="hed-fnt-wt m-0">Download Question Papers</h6>
                                    {courseDetails.length > 0 && (
                                      <button className="btn btn-primary" onClick={() => handleGeneratePDFNewAll()} >Download All</button>
                                    )}

                                  </div>


                                  <table className=" dataTable ex-v-table " ref={tableRef} id="dataTable">
                                    <thead>
                                      <tr className="bg-primary">

                                        <th scope="col" width="7%">Sl No</th>
                                        <th scope="col" width="30%">Subject</th>
                                        <th scope="col" width="15%">Total QP to Print</th>
                                        <th scope="col" width="15%">View/Download</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {courseDetails.length > 0 ? (
                                        courseDetails.map((course, index) => (
                                          <tr key={course.course_id}>
                                            <td className="text-center">{index + 1}</td>
                                            <td>{course.qpcode} - {course.ccode} - {course.cname}</td>
                                            <td className="text-center">{course.cnt}</td>
                                            <td style={{ cursor: "pointer" }}><button
                                              className="lbl2 btn btn-primary m-r-10"
                                              onClick={() => handleGeneratePDFNew(course.qpcode)}
                                              title="Download"
                                            >
                                              <i class="bi bi-arrow-down-square"></i>
                                            </button></td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr><td colSpan="4" className="text-center">No data found</td></tr>
                                      )}

                                    </tbody>
                                  </table>



                                </div>

                              </div>


                            </div>



                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


      </Template>
    </>
  );
}
